import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  evaluationTypesLength: 0,
  evaluationTypes: [],
  evaluationType: {},
  evaluationTypeError: "",
  formError: "",
};

export default function EvaluationTypeReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_EVALUATION_TYPE:
      return { ...state, loading: action.payload };
    case actions.LOADING_EVALUATION_TYPE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_EVALUATION_TYPE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_EVALUATION_TYPE:
      return {
        ...state,
        evaluationTypes: action.payload.evaluationTypes,
        evaluationTypesLength: action.payload.evaluationTypesLength,
      };
    case actions.GET_EVALUATION_TYPE_BY_ID:
      return {
        ...state, evaluationType: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.EVALUATION_TYPE_FAIL:
      return { ...state, evaluationTypeError: action.payload };
    default:
      return state;
  }
}
